/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuWorkerDocsSendToCounterpartPartialUpdateRequest = {} | null | undefined;
export type SvuWorkerDocsSendToCounterpartPartialUpdateResponse = any;

export type SvuWorkerDocsSendToCounterpartPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/send_to_counterpart/
 *
 * ```yaml
 * operationId: svu_worker_docs_send_to_counterpart_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsSendToCounterpartPartialUpdateOperation = ({
  id,
  ...rest
}: SvuWorkerDocsSendToCounterpartPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_worker_docs/${id}/send_to_counterpart/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_worker_docs/{id}/send_to_counterpart/' };
  };

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/send_to_counterpart/
 *
 * ```yaml
 * operationId: svu_worker_docs_send_to_counterpart_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsSendToCounterpartPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuWorkerDocsSendToCounterpartPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuWorkerDocsSendToCounterpartPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
